// extracted by mini-css-extract-plugin
export var background = "cF_kn";
export var body = "cF_h1";
export var button = "cF_bJ";
export var card = "cF_cr";
export var content = "cF_cF";
export var footer = "cF_fF";
export var header = "cF_km";
export var subtitle = "cF_h5";
export var title = "cF_bH";